import { createRouter, createWebHashHistory } from 'vue-router'
import Booking from '../views/Booking.vue'
import Personal from '../views/Personal.vue'
import Confirmation from '../views/Confirmation.vue'
import Confirmed from '../views/Confirmed.vue'
import Reschedule from '../views/Reschedule.vue'
import CancelConfirmed from '../views/CancelConfirmed.vue'

import { initial } from '../utils/countryConfig'

import { useBookingStore, usePersonalStore, useRescheduleStore } from '../store'

const routes = [
  {
    path: '/',
    name: 'BookingView',
    component: Booking,
  },
  {
    path: '/personal',
    name: 'PersonalView',
    component: Personal,
    beforeEnter: (to, from, next) => {
      // check if redirect is allowed
      const bookingStore = useBookingStore()
      if (!bookingStore.personalViewAllowed) {
        next({ name: 'BookingView' })
      } else {
        next()
      }
    },
  },
  {
    path: '/confirmation',
    name: 'ConfirmationView',
    component: Confirmation,
    beforeEnter: (to, from, next) => {
      // check if redirect is allowed
      const personalStore = usePersonalStore()
      if (!personalStore.confirmationViewAllowed) {
        next({ name: 'BookingView' })
      } else {
        next()
      }
    },
  },
  {
    path: '/confirmed',
    name: 'ConfirmedView',
    component: Confirmed,
  },
  {
    name: 'CancelConfirmedView',
    path: '/cancel-appointment-confirmed',
    component: CancelConfirmed,
  },
  {
    path: '/reschedule/:appointmentId?/:processId?',
    name: 'RescheduleView',
    component: Reschedule,
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { left: 0, top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const bookingStore = useBookingStore()
  const rescheduleStore = useRescheduleStore()
  if (
    (to.name == 'BookingView' || to.name == 'RescheduleView' || to.name == 'CancelConfirmedView') &&
    from.name !== 'PersonalView' &&
    from.name !== 'ConfirmationView'
  ) {
    //set app params from url
    const { lang, country, customerType, meetingType } = initial()
    bookingStore.setAppLang(lang)
    bookingStore.setAppCountry(country)
    bookingStore.setCustomerType(customerType)
    bookingStore.setAppointmentTypeFromUrl(meetingType)
  }
  //reschedule view specific params
  if (to.name == 'RescheduleView') {
    const appointmentId = to.params.appointmentId
    const processId = to.params.processId

    if (appointmentId) {
      rescheduleStore.updateAppointmentId(appointmentId)
    }
    if (processId) {
      rescheduleStore.updateProcessId(processId)
    }
  }

  window.parent.postMessage(['scrollToTop'], '*') //send message to parent, to scroll to top on navigation

  return next()
})

export default router
